export const HTML_PARSE_REG = /<[^/>]+>([^<]*)<\/[^/>]+>/g;
export const HTML_PARSE_SINGLE_TAGS = /<\/?[^>]+(>|$)/g;
export const HTML_DELETE_NBSP = /&nbsp;/g;
export const HTML_PARSE_ENTER = /\r?\n|\r/g;
export const HTML_SINGLE_NODE_PARSE = /<\w+\/>/g;

export const parseHTMLToText = (htmlText) => {
  let text = htmlText;
  if (text)
    do {
      text = text
        .replace(HTML_SINGLE_NODE_PARSE, '')
        .replace(HTML_PARSE_SINGLE_TAGS, '')
        .replace(HTML_DELETE_NBSP, ' ')
        .replace(HTML_PARSE_ENTER, ' ')
        .replace(HTML_PARSE_REG, '$1');
    } while (HTML_PARSE_REG.test(text));
  return text;
};

export const catText = (text = '', length) => {
  if (typeof text !== 'string') {
    throw 'Unexpected type';
  }

  // cat double line separator
  text = text.replace(/(?:\r)\n/g, ' ')
    .replace('  ', ' ');

  return text.length > length - 3
    ? text.trim().substr(0, length - 3) + '...'
    : text;
};

export const catHTML = (htmlText, length) => catText(parseHTMLToText(htmlText), length);



// WEBPACK FOOTER //
// ./src/utilites/textUtilites.js